<label *ngIf="label" for="domain">
  <div>{{ label }}<sup class="red" *ngIf="isRequired">*</sup></div>
</label>
<ng-select [ngModel]="multiple ? selectedDomains : selectedDomain"
           (ngModelChange)="onDomainChange($event)"
           (change)="onChange($event)"
           [items]="domainList"
           [loading]="loading"
           [multiple]="multiple"
           [placeholder]="placeholder"
           [searchFn]="searchFn"
           [disabled]="disabled"
           [required]="isRequired"
           bindLabel="name"
           name="domain" id="domain">
</ng-select>
